<section
  *ngIf="(extractableLayers$ | async).length === 0"
>
  <h4>{{ 'sigt.integration.extractByPolygon.form.noCompatibleLayer' | translate }}</h4>
</section>

<form
  class="igo-form"
  [formGroup]="form"
  *ngIf="(extractableLayers$ | async).length > 0"
>
  <div class="igo-input-container">
    <mat-form-field>
      <mat-label>{{
        'sigt.integration.extractByPolygon.form.sourceLayerPlaceholder' | translate
      }}</mat-label>
      <mat-select [(value)]="sourceLayer">
        <mat-option
          *ngFor="let layer of extractableLayers$ | async"
          [value]="layer.id"
          (click)="$event.stopPropagation()"
        >
          <span matListItemTitle>{{ layer.title }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="igo-input-container">
    <mat-form-field>
      <mat-label>{{
        'sigt.integration.extractByPolygon.form.selectionLayerPlaceholder' | translate
      }}</mat-label>
      <mat-select [(value)]="selectionLayer">
        <mat-option
          *ngFor="let layer of selectionLayers$ | async"
          [value]="layer.id"
          (click)="$event.stopPropagation()"
        >
          <span matListItemTitle>{{ layer.title }}</span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="igo-form-button-group">
    <button
      mat-raised-button
      type="button"
      [disabled]="!form.valid || (loading$ | async)"
      (click)="handleFormSubmit(form.value)"
    >
      {{'sigt.integration.extractByPolygon.form.extractButton' | translate}}
    </button>
    <igo-spinner [shown]="loading$ | async"></igo-spinner>
  </div>

</form>  